import { render, staticRenderFns } from "./ProjectDeleteModal.vue?vue&type=template&id=10073eaa&scoped=true&"
import script from "./ProjectDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ProjectDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDeleteModal.vue?vue&type=style&index=0&id=10073eaa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10073eaa",
  null
  
)

export default component.exports